import { faEdit, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import SupplierDelete from "./SupplierDelete";
import SupplierDetailPopup from "./SupplierDetailPopup";

const SupplierActionButton = ({ id, handleDelete }) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showView, setShowView] = useState(false);
  const params = useParams();
  const businessId = params?.business_id;

  const toggleShowModal = () => {
    setShowView(!showView);
  };

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };
  return (
    <>
      <span>
        <FontAwesomeIcon
          onClick={toggleShowModal}
          icon={faEye}
          size="1x"
          data-toggle="modal"
          data-target="#supplierDetail"
        />
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <Link to={`/business/${businessId}/edit-supplier?id=${id}`}>
          <FontAwesomeIcon icon={faEdit} size="1x" />
        </Link>
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <FontAwesomeIcon
          onClick={toggleDeleteModal}
          icon={faTrash}
          size="1x"
          data-toggle="modal"
          data-target="#deleteSupplier"
        />
      </span>

      {showDelete && (
        <SupplierDelete
          supplierId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={handleDelete}
          showDelete={showDelete}
        />
      )}

      {showView && (
        <SupplierDetailPopup
          supplierId={id}
          toggleShowModal={toggleShowModal}
          showView={showView}
        />
      )}
    </>
  );
};

export default SupplierActionButton;
